import { useEffect, useState } from "react";

import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { Box } from "@mui/material";
import { AppFeature } from "features/appFeatures/types/AppFeature";
import { FeatureFlagGuard } from "features/appFeatures/FeatureFlagGuard";

export interface PlayerBottomBarOverlayProps {
    isAudioEnabled: boolean;
    AudioEnabledChanged: (audioEnabled: boolean) => void;
}

export function PlayerBottomBarOverlay(props: PlayerBottomBarOverlayProps) {
    const [isOptionsBarVisible, setOptionsBarVisible] = useState(false);
    let showOptionsBarTimeout: NodeJS.Timeout;

    const showOptionsBar = () => {
        setOptionsBarVisible(true);
        clearTimeout(showOptionsBarTimeout);

        showOptionsBarTimeout = setTimeout(() => {
            setOptionsBarVisible(false);
        }, 5000);
    };

    useEffect(() => {
        window.addEventListener("mousemove", showOptionsBar);

        return () => {
            window.removeEventListener("mousemove", showOptionsBar);
            clearTimeout(showOptionsBarTimeout);
        };
    }, []);

    return (
        <>
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    textAlign: "center",
                    padding: "10px",
                    opacity: isOptionsBarVisible ? 1 : 0,
                    transition: "opacity 0.5s",
                }}
            >
                <FeatureFlagGuard
                    accessibleWithFeatureFlags={[AppFeature.DeviceAudioSupport]}
                >
                    {!props.isAudioEnabled && (
                        <VolumeOffIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                props.AudioEnabledChanged(true);
                            }}
                        />
                    )}
                    {props.isAudioEnabled && (
                        <VolumeUpIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                                props.AudioEnabledChanged(false);
                            }}
                        />
                    )}
                </FeatureFlagGuard>
            </Box>
        </>
    );
}
